import {createSlice} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import Team from '../../api/team'
import {setConfirmIsActive} from '../alert'
import FormHelper from '../../utils/forms'

export const membersSlice = createSlice({
    name: 'members',
    initialState: {
        members: [],
        isMembersLoading: false
    },
    reducers: {
        setMembers: (state, {payload}) => {
            state.members = payload
        },
        setIsMembersLoading: (state, {payload}) => {
            state.isMembersLoading = payload
        }
    }
})

export const {
    setMembers,
    setIsMembersLoading
} = membersSlice.actions

export default membersSlice.reducer

const fetchActiveMembers = async(teamId) => {
    const {data} = await Team.getActiveTeamMembers(teamId)
    return data?.data?.team_members || []
}

const mapTeamMembers = (members, team) =>
    members.map(member => ({
        ...member,
        label: `${member?.name} ${member?.surname} (${team?.name})`,
        value: member?.customer_id,
        team_id: team?.team_id
    }))

export const getActiveMembers = (teamId, showLoader = false) => {
    return async dispatch => {
        showLoader && dispatch(setIsMembersLoading(true))
        try {
            const members = await fetchActiveMembers(teamId)
            dispatch(setMembers(members))
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
        showLoader && dispatch(setIsMembersLoading(false))
    }
}

export const getAllActiveMembers = (teams) => {
    return async() => {
        try {
            const results = await Promise.all(
                teams.map(async(team) => {
                    const members = await fetchActiveMembers(team?.team_id)
                    return mapTeamMembers(members, team)
                })
            )
            return results.flat()
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const getInvitationsMembers = (teamId) => {
    return async() => {
        try {
            const {data} = await Team.getInvitationsMembers(teamId)
            return data?.data?.invitations || {
                message: data?.message
            }
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const addTeamMember = (teamId, values, setFieldError) => {
    return async() => {
        try {
            const {data} = await Team.addTeamMember(teamId, values)
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const deleteMember = (teamId, id, type) => {
    return async dispatch => {
        try {
            let res
            if (type === 'active') {
                res = await Team.deleteTeamMember(teamId, id)
            } else {
                res = await Team.deleteInvitation(teamId, {
                    channel_value: id
                })
            }
            dispatch(setConfirmIsActive(false))
            toast.success(res?.data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }
}

export const remindMember = (teamId, channel) => {
    return async() => {
        try {
            const {data} = await Team.remindTeamMember(teamId, {
                channel_value: channel
            })
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }
}

export const updateTeamMember = (teamId, id, values, setFieldError) => {
    return async() => {
        try {
            const {data} = await Team.updateTeamMember(teamId, id, values)
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}
